import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ServiceCard from "@/components/ServiceCard";

const TABS = [
  { val: "all",         label: "ALL",       filter: () => true },
  { val: "vps",         label: "VPS",       filter: (s) => s.subtype === "vps" },
  { val: "dedicated",   label: "DEDICATED", filter: (s) => s.subtype === "dedicated" },
  { val: "api_services",label: "APIS",      filter: (s) => s.category === "api_services" },
];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const active = params.get("subtype") || params.get("category") || "all";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/services")
      .then((r) => {
        const data = r.data || [];
        const tab = TABS.find((t) => t.val === active) || TABS[0];
        setItems(data.filter(tab.filter));
      })
      .finally(() => setLoading(false));
  }, [active]);

  const setActive = (val) => {
    if (val === "all") setParams({});
    else if (val === "api_services") setParams({ category: val });
    else setParams({ subtype: val });
  };

  return (
    <div data-testid="catalog-page" className="container-pad py-12 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <div className="overline">// CATALOG</div>
          <h1 className="mt-3 font-display text-4xl md:text-5xl tracking-tight">
            Pick your <span className="text-signal">infrastructure.</span>
          </h1>
          <p className="mt-3 text-zinc-400 max-w-xl">
            Cloud servers and developer APIs, all billed monthly in USD.
            Cancel anytime — you keep access through the end of the billing period.
          </p>
        </div>

        <div className="inline-flex items-center gap-1 border border-zinc-800 rounded-sm p-1 bg-zinc-950 self-start flex-wrap">
          {TABS.map((t) => (
            <button
              key={t.val}
              data-testid={`filter-${t.val}`}
              onClick={() => setActive(t.val)}
              className={`font-mono text-xs tracking-widest px-3 py-1.5 rounded-sm transition-colors ${
                active === t.val ? "bg-signal text-black" : "text-zinc-400 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-6">
        {loading && (
          <div className="md:col-span-12 font-mono text-xs tracking-widest text-zinc-500">LOADING…</div>
        )}
        {!loading && items.length === 0 && (
          <div className="md:col-span-12 font-mono text-xs tracking-widest text-zinc-500">// NO RESULTS</div>
        )}
        {!loading && items.map((s) => <ServiceCard key={s.id} svc={s} />)}
      </div>
    </div>
  );
}
